export const vehiclePhotoContentTypes = ["image/jpeg", "image/png", "image/webp"] as const;
export const maxVehiclePhotoBytes = 25 * 1024 * 1024;
export const maxVehiclePhotosPerBatch = 40;
export const photoSceneFlowParam = "scene" as const;

export function removeVehiclePhotoFile(current: readonly File[], removed: File): File[] {
  return current.filter((file) => file !== removed);
}

/**
 * Único enlace de entrada al asistente de escenarios. El alta rápida y la ficha
 * reutilizan así el mismo flujo en vez de mantener dos selectores distintos.
 */
export function vehiclePhotoSceneFlowUrl(vehicleId: string): string {
  return `/app/stock/${encodeURIComponent(vehicleId)}?tab=photos&photoFlow=${photoSceneFlowParam}`;
}

export function isPhotoSceneFlow(value: string | null): boolean {
  return value === photoSceneFlowParam;
}
